import _ from 'lodash';
import React from 'react';

import { ListViewAction } from '@jvs-group/jvs-mairistem-composants';
import {ReactComponent as ReserverSvg} from '../../assets/reserver.svg';

const ReservationListViewAction = (props) => {
    const { onAddClick } = props;

    const handleClick = () => {
        onAddClick();
    }

    if (_.isNil(onAddClick)) {
        return null;
    }

    return (
        <ListViewAction onClick={handleClick}>
            <ReserverSvg
                style={{
                    marginRight: '0.5rem',
                }}
            />
            Ajouter une réservation
        </ListViewAction>
    );
};

export default ReservationListViewAction;